module.exports = __webpack_public_path__ + "static/img/bannerImage.bc82808.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-image/bannerImage.png
// module id = 0e4y
// module chunks = 1